export default __webpack_public_path__ + "static/media/Rubeena.dbb4dcd2.jpeg";